// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__11rNO","buttonWrap":"style_buttonWrap__1SK_v"};